import { all, setContext } from 'redux-saga/effects';
import { saga as translateSaga, createIntlContext } from '@ackee/jerome';

// eslint-disable-next-line
const emptyGenerator = function* () {};

const createRootSaga = (saga = emptyGenerator) => {
    const rootSaga = function* rootSaga(...args) {
        yield setContext(createIntlContext());

        yield all([translateSaga(), saga(...args)]);
    };

    return rootSaga;
};

export default createRootSaga;
